interface RecoveryEntryConfig {
  MANAGEMENT_PORTAL_URL?: unknown;
  ENVIRONMENT?: unknown;
  RECOVERY_APPLICATION_ID?: unknown;
}
export type RecoveryEntryResult = { available: false; reason: string } | {
  available: true; applicationUrl: string; environment: string; application: string;
};
const validId = (value: unknown): value is string => typeof value === 'string' && /^[a-zA-Z0-9][a-zA-Z0-9_.-]{0,127}$/.test(value);

/** Configuration is routing context only. The Admin service reauthorizes every scope. */
export function recoveryEntry(value: unknown): RecoveryEntryResult {
  const config = value !== null && typeof value === 'object' && !Array.isArray(value) ? value as RecoveryEntryConfig : null;
  if (!config || typeof config.MANAGEMENT_PORTAL_URL !== 'string' || !validId(config.ENVIRONMENT) || !validId(config.RECOVERY_APPLICATION_ID)) {
    return { available: false, reason: 'The management portal address and recovery scope are not configured for this portal.' };
  }
  let origin: URL;
  try { origin = new URL(config.MANAGEMENT_PORTAL_URL); }
  catch { return { available: false, reason: 'The configured management portal address is invalid.' }; }
  if (origin.protocol !== 'https:' || origin.username || origin.password || origin.search || origin.hash || origin.pathname !== '/') {
    return { available: false, reason: 'The management portal must be configured as a trusted HTTPS origin without credentials or query parameters.' };
  }
  // The legacy application wire scope is the full registered business portal.
  // Historical portal-subset links remain readable in Admin but are never created here.
  const url = new URL('/operations/recovery/backups', origin);
  url.search = new URLSearchParams({ recovery_view: 'capture', recovery_env: config.ENVIRONMENT as string,
    recovery_level: 'application', recovery_app: config.RECOVERY_APPLICATION_ID as string }).toString();
  return { available: true, applicationUrl: url.toString(),
    environment: config.ENVIRONMENT, application: config.RECOVERY_APPLICATION_ID };
}
